import {
  resolvePredictionMarketFields,
  type IPredictionOutcomeEvent,
  type IPredictionOutcomeEventSeriesRecord,
  type PredictionMarketResolvedFields,
  type Security,
} from '@talos/kyoko';

/**
 * Category / series / event metadata for a prediction-outcome symbol.
 * Used to populate blotter grouping columns and to apply client-side Series/Event filters —
 * not the blotter's AG Grid row-grouping mode itself.
 */
export type PredictionSymbolMetadata = PredictionMarketResolvedFields;

/**
 * Resolves a prediction-outcome symbol to its series and event details so grouping columns
 * and Series/Event filters can decide what to show for that row.
 */
export function resolvePredictionSymbolMetadata(
  symbol: string | undefined,
  securitiesBySymbol: Map<string, Security>,
  eventsByID: Map<string, IPredictionOutcomeEvent>,
  eventSeriesByID: Map<string, IPredictionOutcomeEventSeriesRecord>
): PredictionSymbolMetadata {
  return resolvePredictionMarketFields(symbol, {
    securitiesBySymbol,
    predictionEventsByID: eventsByID,
    predictionEventSeriesByID: eventSeriesByID,
  });
}

export function isPredictionPositionExcludedByFilters(
  metadata: PredictionSymbolMetadata,
  seriesIDs: string[] | undefined,
  eventIDs: string[] | undefined
): boolean {
  if (seriesIDs?.length && (metadata.seriesID == null || !seriesIDs.includes(metadata.seriesID))) {
    return true;
  }
  if (eventIDs?.length && (metadata.eventID == null || !eventIDs.includes(metadata.eventID))) {
    return true;
  }
  return false;
}
